export default {
  title: 'My Partner Space',
  titlePrefix: '',
  ErrorTitle: 'Technical error',
  ErrorMessage: 'An error has occured. We apologize for the inconvenience.',
  ErrorRetryButton: 'Retry',
  NotFoundTitle: 'Page not found',
  NotFoundMessage: 'Sorry, the page may have been moved or deleted.',
  NotFoundBackButton: 'Back',
  copyright: `© ${new Date().getFullYear()} iA Financial Group is a business name and trademark of Industrial Alliance Insurance and Financial Services Inc.`,
};
